module.exports = __webpack_public_path__ + "img/ic_paid.a82948fb.svg";